export const CONFIRMED_SET_LOCATIONID = '[Location Action] Set Location Id';
export const CONFIRMED_GET_LOCATIONS = '[Location Action] Get Locations';